document.addEventListener("DOMContentLoaded", function () {
  const questions = document.querySelectorAll(".question");

  questions.forEach((question) => {
    question.addEventListener("click", () => {
      // Toggle active class on question
      question.classList.toggle("active");

      // Toggle active class on answer
      const answer = question.nextElementSibling;
      answer.classList.toggle("active");

      // Close other answers
      questions.forEach((otherQuestion) => {
        if (otherQuestion !== question) {
          otherQuestion.classList.remove("active");
          otherQuestion.nextElementSibling.classList.remove("active");
        }
      });
    });
  });
});
